var _path, _g, _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCopytradingQr = function SvgCopytradingQr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    viewBox: "0 0 328 328"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h328v328H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#334875"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 16h8.24v8.24H80zm24 0h8.24v8.24H104zm16 0h8.24v8.24H120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 16h8.24v8.24H128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 16h8.24v8.24H136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 16h8.24v8.24H144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 16h8.24v8.24H152zm16 0h8.24v8.24H168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 16h8.24v8.24H176zm24 0h8.24v8.24H200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 16h8.24v8.24H208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 16h8.24v8.24H216zm24 0h8.24v8.24H240zM80 24h8.24v8.24H80zm16 0h8.24v8.24H96zm24 0h8.24v8.24H120z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 24h8.24v8.24H128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 24h8.24v8.24H136zm16 0h8.24v8.24H152zm32 0h8.24v8.24H184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 24h8.24v8.24H192zm16 0h8.24v8.24H208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 24h8.24v8.24H216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 24h8.24v8.24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 24h8.24v8.24H232zM80 32h8.24v8.24H80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 32h8.24v8.24H88zm16 0h8.24v8.24H104zm16 0h8.24v8.24H120zm16 0h8.24v8.24H136zm16 0h8.24v8.24H152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 32h8.24v8.24H160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 32h8.24v8.24H168zm32 0h8.24v8.24H200zm24 0h8.24v8.24H224zm16 0h8.24v8.24H240zM96 40h8.24v8.24H96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 40h8.24v8.24H104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 40h8.24v8.24H112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 40h8.24v8.24H120zm16 0h8.24v8.24H136zm48 0h8.24v8.24H184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 40h8.24v8.24H192zm24 0h8.24v8.24H216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 40h8.24v8.24H224zM88 48h8.24v8.24H88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 48h8.24v8.24H96zm16 0h8.24v8.24H112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 48h8.24v8.24H120zm24 0h8.24v8.24H144zm40 0h8.24v8.24H184zM80 56h8.24v8.24H80zm16 0h8.24v8.24H96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 56h8.24v8.24H112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 56h8.24v8.24H120zm24 0h8.24v8.24H144zm40 0h8.24v8.24H184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 56h8.24v8.24H192zm40 0h8.24v8.24H232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 56h8.24v8.24H240zM80 64h8.24v8.24H80zm16 0h8.24v8.24H96zm16 0h8.24v8.24H112zm16 0h8.24v8.24H128zm16 0h8.24v8.24H144zm16 0h8.24v8.24H160zm16 0h8.24v8.24H176zm16 0h8.24v8.24H192zm16 0h8.24v8.24H208zm16 0h8.24v8.24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 64h8.24v8.24H240zM80 72h8.24v8.24H80zm32 0h8.24v8.24H112zm32 0h8.24v8.24H144zm16 0h8.24v8.24H160zm16 0h8.24v8.24H176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 72h8.24v8.24H184zm16 0h8.24v8.24H200zm24 0h8.24v8.24H224zm16 0h8.24v8.24H240zM32 80h8.24v8.24H32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 80h8.24v8.24H40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 80h8.24v8.24H48zm16 0h8.24v8.24H64zm16 0h8.24v8.24H80zm24 0h8.24v8.24H104zm32 0h8.24v8.24H136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 80h8.24v8.24H144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 80h8.24v8.24H152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 80h8.24v8.24H160zm32 0h8.24v8.24H192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 80h8.24v8.24H200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 80h8.24v8.24H208zm40 0h8.24v8.24H248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 80h8.24v8.24H256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 80h8.24v8.24H264zm24 0h8.24v8.24H288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 80h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 80h8.24v8.24H304zM56 88h8.24v8.24H56zm16 0h8.24v8.24H72zm16 0h8.24v8.24H88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 88h8.24v8.24H96zm32 0h8.24v8.24H128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 88h8.24v8.24H136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 88h8.24v8.24H144zm16 0h8.24v8.24H160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 88h8.24v8.24H168zm16 0h8.24v8.24H184zm24 0h8.24v8.24H208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 88h8.24v8.24H216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 88h8.24v8.24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 88h8.24v8.24H232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 88h8.24v8.24H240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 88h8.24v8.24H248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 88h8.24v8.24H256zm24 0h8.24v8.24H280z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 88h8.24v8.24H288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 88h8.24v8.24H296zM16 96h8.24v8.24H16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 96h8.24v8.24H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 96h8.24v8.24H32zm16 0h8.24v8.24H48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 96h8.24v8.24H56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 96h8.24v8.24H64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 96h8.24v8.24H72zm16 0h8.24v8.24H88zm16 0h8.24v8.24H104zm16 0h8.24v8.24H120zm16 0h8.24v8.24H136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 96h8.24v8.24H144zm24 0h8.24v8.24H168zm32 0h8.24v8.24H200zm16 0h8.24v8.24H216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 96h8.24v8.24H224zm32 0h8.24v8.24H256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 96h8.24v8.24H264zm16 0h8.24v8.24H280zm16 0h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 96h8.24v8.24H304zm-288 8h8.24v8.24H16zm16 0h8.24v8.24H32zm16 0h8.24v8.24H48zm24 0h8.24v8.24H72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 104h8.24v8.24H80zm16 0h8.24v8.24H96zm24 0h8.24v8.24H120zm24 0h8.24v8.24H144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 104h8.24v8.24H152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 104h8.24v8.24H160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 104h8.24v8.24H168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 104h8.24v8.24H176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 104h8.24v8.24H184zm16 0h8.24v8.24H200zm24 0h8.24v8.24H224zm16 0h8.24v8.24H240zm16 0h8.24v8.24H256zm40 0h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 104h8.24v8.24H304zm-280 8h8.24v8.24H24zm32 0h8.24v8.24H56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 112h8.24v8.24H64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 112h8.24v8.24H72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 112h8.24v8.24H80zm16 0h8.24v8.24H96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 112h8.24v8.24H104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 112h8.24v8.24H112zm16 0h8.24v8.24H128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 112h8.24v8.24H136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 112h8.24v8.24H144zm16 0h8.24v8.24H160zm16 0h8.24v8.24H176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 112h8.24v8.24H184zm32 0h8.24v8.24H216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 112h8.24v8.24H224zm24 0h8.24v8.24H248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 112h8.24v8.24H256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 112h8.24v8.24H264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 112h8.24v8.24H272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 112h8.24v8.24H280z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 112h8.24v8.24H288zm16 0h8.24v8.24H304zm-248 8h8.24v8.24H56zm152 0h8.24v8.24H208zm32 0h8.24v8.24H240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 120h8.24v8.24H248zm16 0h8.24v8.24H264zm16 0h8.24v8.24H280z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 120h8.24v8.24H288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 120h8.24v8.24H296zm-280 8h8.24v8.24H16zm16 0h8.24v8.24H32zm32 0h8.24v8.24H64zm16 0h8.24v8.24H80zm16 0h8.24v8.24H96zm16 0h8.24v8.24H112zm104 0h8.24v8.24H216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 128h8.24v8.24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 128h8.24v8.24H232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 128h8.24v8.24H240zm16 0h8.24v8.24H256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 128h8.24v8.24H264zm16 0h8.24v8.24H280zm16 0h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 128h8.24v8.24H304zm-288 8h8.24v8.24H16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 136h8.24v8.24H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 136h8.24v8.24H32zm24 0h8.24v8.24H56zm16 0h8.24v8.24H72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 136h8.24v8.24H80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 136h8.24v8.24H88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 136h8.24v8.24H96zm16 0h8.24v8.24H112zm112 0h8.24v8.24H224zm24 0h8.24v8.24H248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 136h8.24v8.24H256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 136h8.24v8.24H264zm40 0h8.24v8.24H304zm-288 8h8.24v8.24H16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 144h8.24v8.24H24zm16 0h8.24v8.24H40zm24 0h8.24v8.24H64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 144h8.24v8.24H72zm16 0h8.24v8.24H88zm16 0h8.24v8.24H104z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112 144h8.24v8.24H112zm96 0h8.24v8.24H208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 144h8.24v8.24H216zm16 0h8.24v8.24H232zm16 0h8.24v8.24H248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 144h8.24v8.24H256zm16 0h8.24v8.24H272zm16 0h8.24v8.24H288zm16 0h8.24v8.24H304zm-272 8h8.24v8.24H32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 152h8.24v8.24H40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 152h8.24v8.24H48zm24 0h8.24v8.24H72zm16 0h8.24v8.24H88zm16 0h8.24v8.24H104zm112 0h8.24v8.24H216zm24 0h8.24v8.24H240zm24 0h8.24v8.24H264zm16 0h8.24v8.24H280z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 152h8.24v8.24H288zm-272 8h8.24v8.24H16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 160h8.24v8.24H24zm32 0h8.24v8.24H56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 160h8.24v8.24H64zm48 0h8.24v8.24H112zm96 0h8.24v8.24H208zm16 0h8.24v8.24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 160h8.24v8.24H232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 160h8.24v8.24H240zm32 0h8.24v8.24H272zm24 0h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 160h8.24v8.24H304zm-288 8h8.24v8.24H16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 168h8.24v8.24H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 168h8.24v8.24H32zm16 0h8.24v8.24H48zm48 0h8.24v8.24H96zm128 0h8.24v8.24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 168h8.24v8.24H232zm24 0h8.24v8.24H256zm40 0h8.24v8.24H296zm-272 8h8.24v8.24H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 176h8.24v8.24H32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 176h8.24v8.24H40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 176h8.24v8.24H48zm16 0h8.24v8.24H64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 176h8.24v8.24H72zm40 0h8.24v8.24H112zm96 0h8.24v8.24H208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 176h8.24v8.24H216zm40 0h8.24v8.24H256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 176h8.24v8.24H264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 176h8.24v8.24H272zm16 0h8.24v8.24H288zm16 0h8.24v8.24H304zm-272 8h8.24v8.24H32zm24 0h8.24v8.24H56zm16 0h8.24v8.24H72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 184h8.24v8.24H80zm16 0h8.24v8.24H96zm16 0h8.24v8.24H112zm96 0h8.24v8.24H208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 184h8.24v8.24H216zm48 0h8.24v8.24H264zm16 0h8.24v8.24H280zm16 0h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 184h8.24v8.24H304zm-280 8h8.24v8.24H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 192h8.24v8.24H32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 192h8.24v8.24H40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 192h8.24v8.24H48zm16 0h8.24v8.24H64z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 192h8.24v8.24H72zm16 0h8.24v8.24H88zm16 0h8.24v8.24H104zm112 0h8.24v8.24H216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 192h8.24v8.24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 192h8.24v8.24H232zm16 0h8.24v8.24H248zm32 0h8.24v8.24H280z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 192h8.24v8.24H288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 192h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 192h8.24v8.24H304zm-288 8h8.24v8.24H16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 200h8.24v8.24H24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 200h8.24v8.24H32zm48 0h8.24v8.24H80zm16 0h8.24v8.24H96zm112 0h8.24v8.24H208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 200h8.24v8.24H216zm48 0h8.24v8.24H264zm32 0h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 200h8.24v8.24H304zm-280 8h8.24v8.24H24zm16 0h8.24v8.24H40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 208h8.24v8.24H48zm16 0h8.24v8.24H64zm16 0h8.24v8.24H80zm24 0h8.24v8.24H104zm24 0h8.24v8.24H128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 208h8.24v8.24H136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 208h8.24v8.24H144zm56 0h8.24v8.24H200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 208h8.24v8.24H208zm16 0h8.24v8.24H224zm16 0h8.24v8.24H240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 208h8.24v8.24H248zm32 0h8.24v8.24H280z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 208h8.24v8.24H288zm16 0h8.24v8.24H304zm-288 8h8.24v8.24H16zm32 0h8.24v8.24H48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 216h8.24v8.24H56zm16 0h8.24v8.24H72zm16 0h8.24v8.24H88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 216h8.24v8.24H96zm16 0h8.24v8.24H112zm16 0h8.24v8.24H128zm16 0h8.24v8.24H144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 216h8.24v8.24H152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 216h8.24v8.24H160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 216h8.24v8.24H168zm24 0h8.24v8.24H192zm40 0h8.24v8.24H232zm24 0h8.24v8.24H256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 216h8.24v8.24H264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 216h8.24v8.24H272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 216h8.24v8.24H280z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 216h8.24v8.24H288zm-272 8h8.24v8.24H16zm16 0h8.24v8.24H32zm16 0h8.24v8.24H48z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 224h8.24v8.24H56z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 224h8.24v8.24H64zm24 0h8.24v8.24H88zm16 0h8.24v8.24H104zm24 0h8.24v8.24H128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 224h8.24v8.24H136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 224h8.24v8.24H144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 224h8.24v8.24H152zm16 0h8.24v8.24H168zm24 0h8.24v8.24H192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 224h8.24v8.24H200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 224h8.24v8.24H208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 224h8.24v8.24H216zm16 0h8.24v8.24H232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 224h8.24v8.24H240zm16 0h8.24v8.24H256zm16 0h8.24v8.24H272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 224h8.24v8.24H280z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288 224h8.24v8.24H288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 224h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 224h8.24v8.24H304zm-288 8h8.24v8.24H16zm88 0h8.24v8.24H104zm48 0h8.24v8.24H152zm24 0h8.24v8.24H176zm16 0h8.24v8.24H192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 232h8.24v8.24H200zm24 0h8.24v8.24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 232h8.24v8.24H232zm16 0h8.24v8.24H248zm16 0h8.24v8.24H264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 232h8.24v8.24H272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 232h8.24v8.24H280zm16 0h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 232h8.24v8.24H304zm-288 8h8.24v8.24H16zm16 0h8.24v8.24H32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 240h8.24v8.24H40zm24 0h8.24v8.24H64zm16 0h8.24v8.24H80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 240h8.24v8.24H88zm40 0h8.24v8.24H128zm16 0h8.24v8.24H144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 240h8.24v8.24H152zm16 0h8.24v8.24H168zm32 0h8.24v8.24H200zm16 0h8.24v8.24H216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 240h8.24v8.24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 240h8.24v8.24H232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 240h8.24v8.24H240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 240h8.24v8.24H248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 240h8.24v8.24H256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 240h8.24v8.24H264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 240h8.24v8.24H272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 240h8.24v8.24H280zm16 0h8.24v8.24H296zm-216 8h8.24v8.24H80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 248h8.24v8.24H88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 248h8.24v8.24H96zm16 0h8.24v8.24H112zm40 0h8.24v8.24H152zm16 0h8.24v8.24H168zm16 0h8.24v8.24H184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 248h8.24v8.24H192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 248h8.24v8.24H200zm16 0h8.24v8.24H216zm16 0h8.24v8.24H232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 248h8.24v8.24H240zm32 0h8.24v8.24H272zm24 0h8.24v8.24H296zm-184 8h8.24v8.24H112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 256h8.24v8.24H120zm16 0h8.24v8.24H136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 256h8.24v8.24H144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 256h8.24v8.24H152zm16 0h8.24v8.24H168zm16 0h8.24v8.24H184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192 256h8.24v8.24H192zm16 0h8.24v8.24H208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 256h8.24v8.24H216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 256h8.24v8.24H224zm16 0h8.24v8.24H240zm16 0h8.24v8.24H256zm16 0h8.24v8.24H272z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 256h8.24v8.24H280zm16 0h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 256h8.24v8.24H304zm-216 8h8.24v8.24H88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 264h8.24v8.24H96zm24 0h8.24v8.24H120zm40 0h8.24v8.24H160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 264h8.24v8.24H168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 264h8.24v8.24H176zm16 0h8.24v8.24H192z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 264h8.24v8.24H200z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208 264h8.24v8.24H208zm32 0h8.24v8.24H240zm32 0h8.24v8.24H272zm24 0h8.24v8.24H296zm-216 8h8.24v8.24H80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 272h8.24v8.24H88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 272h8.24v8.24H96zm16 0h8.24v8.24H112z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 272h8.24v8.24H120zm16 0h8.24v8.24H136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 272h8.24v8.24H144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 272h8.24v8.24H152z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 272h8.24v8.24H160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 272h8.24v8.24H168zm48 0h8.24v8.24H216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 272h8.24v8.24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 272h8.24v8.24H232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 272h8.24v8.24H240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 272h8.24v8.24H248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 272h8.24v8.24H256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 272h8.24v8.24H264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 272h8.24v8.24H272zm16 0h8.24v8.24H288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 272h8.24v8.24H296zm-216 8h8.24v8.24H80zm48 0h8.24v8.24H128zm16 0h8.24v8.24H144zm16 0h8.24v8.24H160z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 280h8.24v8.24H168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176 280h8.24v8.24H176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 280h8.24v8.24H184zm24 0h8.24v8.24H208z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216 280h8.24v8.24H216zm16 0h8.24v8.24H232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 280h8.24v8.24H240zm16 0h8.24v8.24H256zm16 0h8.24v8.24H272zm-192 8h8.24v8.24H80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 288h8.24v8.24H88zm16 0h8.24v8.24H104zm24 0h8.24v8.24H128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 288h8.24v8.24H136z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 288h8.24v8.24H144zm24 0h8.24v8.24H168zm16 0h8.24v8.24H184zm32 0h8.24v8.24H216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 288h8.24v8.24H224zm16 0h8.24v8.24H240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 288h8.24v8.24H248zm16 0h8.24v8.24H264zm16 0h8.24v8.24H280zm24 0h8.24v8.24H304zm-216 8h8.24v8.24H88z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96 296h8.24v8.24H96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 296h8.24v8.24H104zm24 0h8.24v8.24H128zm32 0h8.24v8.24H160zm16 0h8.24v8.24H176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 296h8.24v8.24H184zm24 0h8.24v8.24H208zm16 0h8.24v8.24H224z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232 296h8.24v8.24H232z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240 296h8.24v8.24H240z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248 296h8.24v8.24H248z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 296h8.24v8.24H256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 296h8.24v8.24H264z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272 296h8.24v8.24H272zm32 0h8.24v8.24H304zm-208 8h8.24v8.24H96zm32 0h8.24v8.24H128z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 304h8.24v8.24H136zm40 0h8.24v8.24H176z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 304h8.24v8.24H184zm32 0h8.24v8.24H216zm40 0h8.24v8.24H256z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 304h8.24v8.24H264zm24 0h8.24v8.24H288z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296 304h8.24v8.24H296z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 304h8.24v8.24H304zM16 16v56h56V16H16zm48 48H24V24h40v40zm192-48v56h56V16h-56zm48 48h-40V24h40v40zM16 256v56h56v-56H16zm48 48H24v-40h40v40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 32h24v24H32zm240 0h24v24h-24zM32 272h24v24H32z"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTIiIGhlaWdodD0iNTIiIHZpZXdCb3g9IjAgMCA1MiA1MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjUyIiBoZWlnaHQ9IjUyIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNOC41IDE5Ljg0OTRWOC41TDI2IDIzLjQwMDZWMzQuNzVMOC41IDE5Ljg0OTRaIiBmaWxsPSIjMzA3MUVFIi8+CjxwYXRoIGQ9Ik00My41IDguNVYxOS44NDk0TDI2IDM0Ljc1VjIzLjQwMDZMNDMuNSA4LjVaIiBmaWxsPSIjMkQ1NERFIi8+CjxwYXRoIGQ9Ik04LjUgMzIuMjVMMTQuNzUgMzcuODc1TDguNSA0My41VjMyLjI1MjVWMzIuMjVaIiBmaWxsPSIjMzA3MUVFIi8+CjxwYXRoIGQ9Ik00My41IDMyLjI1TDM3LjI1IDM3Ljg3NUw0My41IDQzLjVWMzIuMjUyNVYzMi4yNVoiIGZpbGw9IiMyRDU0REUiLz4KPC9zdmc+Cg==",
    width: 70.4,
    height: 70.4,
    x: 128.8,
    y: 128.8
  })));
};
export { SvgCopytradingQr as ReactComponent };
export default __webpack_public_path__ + "static/copytrading_qr.5c297265.svg";